import styled from "styled-components";

export const StyledFeedbackIconWrapper = styled.div<{ flip?: boolean }>`
    ${({ flip }) => flip && "transform: rotateY(180deg);"}
`;
